import React from 'react';
import { useLocation } from 'react-router-dom';
import { Col } from 'components/Base/Grid';
import Button from 'components/Base/Button';
import TextLink, { ETextLinkColors } from 'components/Base/TextLink';
import { FontWeights } from 'core/CssVariables';

import ResendVerificationCodeButton from './components/ResendVerificationCodeButton';
import ResendVerificationCodeButtonForPasswordReset from './components/ResendVerificationCodeButtonForPasswordReset';
import ButtonGroup from './components/ButtonGroup';
import { ELink, ELinkText, EQuestion } from '../LoginButtonGroups/type';
import { EMode, TLoginFooterProps } from './LoginFooter.types';

const LoginFooter = ({
  mode,
  onClick,
  onLinkClick = () => {
    /* do nothing */
  },
  children = null,
  loading = false,
  formId,
  hideSecondaryAction,
  disabled = false,
}: TLoginFooterProps) => {
  const location = useLocation();

  return (
    <Col className="pt-2">
      <Button
        disabled={disabled}
        loading={loading}
        className="w-100 mb-2"
        htmlType="submit"
        onClick={onClick}
        form={formId}
      >
        {EMode[mode]}
      </Button>
      {!!children && children}
      {!hideSecondaryAction && (
        <TextLink
          className="mt-3"
          linkText={ELinkText[mode]}
          to={{ pathname: `${ELink[mode]}`, search: location.search }}
          onClick={onLinkClick}
          type={ETextLinkColors.BLACK}
          fontWeight={FontWeights.Medium}
          fontLevel={5}
        >
          {EQuestion[mode]}
        </TextLink>
      )}
    </Col>
  );
};

export {
  ResendVerificationCodeButton,
  ResendVerificationCodeButtonForPasswordReset,
  ButtonGroup,
};

export default LoginFooter;
